











































































































import Vue from 'vue'
import Input from '@/components/ui/Input.vue'
import { DeresmaGaineForm } from '@/models/SeismicForm'

export default Vue.extend({
  components: {
    Input
  },
  props: {
    form: {
      type: Object as () => DeresmaGaineForm,
      required: true
    },
    showsSelect: {
      type: Boolean,
      required: false
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },

  data () {
    return {
      newSection: {
        section: '',
        epaisseur: ''
      }
    }
  },
  methods: {

    addSection () {
      if (this.newSection.section && this.newSection.epaisseur) {
        if (!Array.isArray(this.form.data.section_epaisseur)) {
          this.$set(this.form, 'section_epaisseur', [])
        }

        if (this.form.data.section_epaisseur) {
          this.form.data.section_epaisseur.push({ ...this.newSection })
        }
        this.newSection.section = ''
        this.newSection.epaisseur = ''
      }
    },
    removeSection (index: number) {
      if (Array.isArray(this.form.data?.section_epaisseur)) {
        if (this.form.data.section_epaisseur) {
          this.form.data.section_epaisseur.splice(index, 1)
        }
      }
    }

  }
})
